import React, { Component } from 'react';
import NewsConfiguration from '../../../../src/models/NewsConfiguration';
import NewsWidgetBlock from '../views/NewsWidgetBlock';
import NewsArticle from '../../../../src/models/NewsArticle';
import Cookies from 'universal-cookie';

type NewsWidgetPageProps = {
    configuration: NewsConfiguration,
}

type NewsWidgetPageState = {
  visibile: boolean
}

export default class NewsWidgetPage extends Component<NewsWidgetPageProps, NewsWidgetPageState> {

    constructor(props: NewsWidgetPageProps) {
        super(props);
        this.state = {
          visibile: true
        };
    }

    public async componentDidMount() {
    }

    public updateSeenNews(): void {
      const cookies = new Cookies();
      let seenNews = cookies.get('seenNewsWidget') ?? [];
      seenNews = [
        ...seenNews,
        ...this.props.configuration.articles.map(a => a.nodeGUID)
      ];

      cookies.set('seenNewsWidget', seenNews, { path: '/', maxAge: 31556926, secure: true });
      this.setState({
        visibile: false
      })
    }

    public render() {
        return (
          <>
            {
                this.state.visibile &&
                <section className={"bg-primary py-3 py-md-4 bg-blob bg-blob-left " + "bg-blob-" + (Math.floor(Math.random() * 5) + 1)} >
                    <div className="container">
                        <div className="row">
                            {
                                this.props.configuration.imageUrl.length > 0 &&

                                <div className="col-12 col-md-3 d-none d-md-block">
                                    <img src={this.props.configuration.imageUrl} alt="" className="mw-100" height="150"/>
                                </div>
                            }
                            <div className="col-12 col-md-9 d-flex flex-column flex-md-row justify-content-md-end">
                              <div className="text-right order-first order-md-last" >
                                <img className="mb-3 cursor-pointer ml-md-2" src="/img/svg/icon-x-transparent-white.svg" alt="" onClick={() => {this.updateSeenNews();}} />
                              </div>
                              {
                                this.props.configuration.articles.map((article: NewsArticle, index: number) => {
                                  return (
                                    <NewsWidgetBlock importantUpdateText={this.props.configuration.importantUpdateText} article={article} key={index}></NewsWidgetBlock>
                                  )
                                })
                              }
                            </div>
                        </div>
                    </div>
                </section>
            }
          </>
        );
    }
}